import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { useLocation } from 'react-router-dom'
import { Link, Icon } from '@/components'
import { useType, useCnType } from '@/hooks'
import { useScroll } from 'ahooks'

import zh_fakao_logo from '@/public/images/zh-fakao.png'

import st from './index.scss'
import search from './imgs/search.png'
import clos from './imgs/clos.png'
import { sendHomePageBuryingPoint, sendWebNavBuryingPoint } from '@/utils/buryPoints'
function Item({ data, ...props }) {
    return (
        <div {...props}>
            {data.map((child, index) => {
                return (
                    <Link
                        key={index}
                        className={st['child-item']}
                        to={child.link}
                        useorigin={child.origin}
                        // onClick={() => { sendWebNavBuryingPoint({ title: child.name }) }}
                    >
                        {child.name}
                    </Link>
                )
            })}
        </div>
    )
}

function Div({ to, origin, children, ...props }) {
    return <div {...props}>{children}</div>
}

export default function Topbar({ className }) {
    const type = useType()
    const cn_type = useCnType()
    const location = useLocation()
    const [hover, setHover] = useState(false)


    // 分成多段 是为了控制在某些条件下 某一段不显示
    // 如果条件很多，可以把数组转成对象去操作
    let list = [
        [
            {
                name: '首页',
                link: `/${type}/`
            },
            {
                name: '公开课',
                link: `/${type}/open`
            },
            {
                name: '商城',
                link: `/${type}/recommend`
            },
            {
                name: '积分商城',
                link: `/${type}/points`,
                // origin: true
            },
            {
                name: '师资',
                link: `/${type}/teacher`
            }
        ],
        [
            {
                name: '资讯',
                link: `/${type}/news`
            }
        ],
        [
            {
                name:  type == 'fakao'?'全国分校':'教学计划',
                link: type == 'fakao'? `/${type}/branchCampus` : `/${type}/rich-text?id=22`,
                // children: [
                //     {
                //         name: '教学计划',
                //         link:
                //             type == 'fakao'
                //                 ? `/${type}/rich-text?id=17`
                //                 : `/${type}/rich-text?id=22`
                //     }
                // ]
            },
        
        ]
    ]

    const aboutUs = {
      name: '关于我们',
      children: [
          {
              name: '关于众合',
              link: `/${type}/about`
          },
          {
              name: '众合招聘',
              link: `/${type}/mall/recruit/home`
          },
          {
              name: '合作单位',
              link: `/${type}/cooperate`
          }
      ]
  }

    if (type == 'fakao') {
        list = [...list[0], ...list[1], ...list[2]]
    } else {
        list = [...list[0], ...list[2]]
    }

    const [searchValue, setSearchValue] = useState('')
    //搜索框
    function searchChange(e) {
        setSearchValue(e.target.value)
    }
    //回车事件
    function searchKeyDown(e) {
        if (e.keyCode == 13) {
            sendHomePageBuryingPoint({title:'课程搜索'})
            searchClick(e)
        }
    }
    function searchClos() {
        setSearchValue('')
    }
    function searchClick() {
        window.open(`/${type}/searchResult?keyword=${searchValue}`)
    }

    const scroll = useScroll(document);

    const shangcheng = ['/recommend', '/book', '/wangshou', '/mianshou', '/fashuo/goods-by-params', '/fakao/goods-by-params']
    const teacher = ['/teacher']
    const aboutOur = ['/fakao/cooperate','/fakao/about','/fashuo/cooperate','/fashuo/about']
    const homepage = ['/fakao/','/fashuo/','/fakao','/fashuo']
    useEffect(()=>{
        if (homepage.some(i=>i == location.pathname)) {
            sendWebNavBuryingPoint({ title: '首页' })
        } else if (location.pathname.includes('/open')) {
            sendWebNavBuryingPoint({ title: '公开课' })
        } else if (shangcheng.some((i) => location.pathname.includes(i))) {
            sendWebNavBuryingPoint({ title: '商城' })
        } else if (location.pathname.includes('/points')) {
            sendWebNavBuryingPoint({ title: '积分商城' })
        } else if (location.pathname.includes('/teacher')) {
            sendWebNavBuryingPoint({ title: '师资' })
        } else if (location.pathname.includes('/news')) {
            sendWebNavBuryingPoint({ title: '资讯' })
        } else if (location.pathname.includes('/branchCampus')) {
            sendWebNavBuryingPoint({ title: '全国分校' })
        } else if (aboutOur.includes(location.pathname)) {
            sendWebNavBuryingPoint({ title: '关于我们' })
        }
    },[location.pathname])
    return (
        <div className={cn(st['box'], className, {[st.bar]: scroll?.top>44 } )}>
            <div className={cn('content', st['tripe'])}>
                <div className={st['logo-box']}>
                    <img src={zh_fakao_logo} className={st['logo']} />
                    <div className={st['lie']}></div>
                    <div>{cn_type}</div>
                </div>
                <div className={st.link}>
                  {list.map((item, index) => {
                    const Dom = item.children ? Div : Link

                    return (
                      <Dom
                        key={index}
                        className={cn({
                          [st['item']]: true,
                          [st['activeTabbar']]:
                            item?.children?.filter(
                              (temp) => temp.link == location.pathname
                            ).length > 0 ||
                            item.link.split('?')[0] == location.pathname || 
                            item.link.split('?')[0] == location.pathname + '/' || 
                            (item.name == '公开课' && (/^\/(fakao|fashuo)\/openclass\/[\w-]+$/).test(location.pathname)),
                          [st.jifenshangcheng]: location.pathname.includes('points') && item.name == "积分商城",
                          [st.zixun]: location.pathname.includes('news') && item.name == "资讯",
                          [st.shangcheng]: shangcheng.some((i) => location.pathname.includes(i)) && item.name=="商城",
                          [st.teacher]: teacher.some((i) => location.pathname.includes(i)) && (item.name=="师资" ) , 
                          [st.shouye]: window.location.href.endsWith('shouye') && (location.pathname.startsWith('/fakao/open') || location.pathname.startsWith('/fashuo/open')) && item.name == '商城'
                        })}
                        to={item.link}
                        useorigin={item.origin}
                        onClick={() => {
                        //   if (item.name != '全国分校' && item.name != '关于我们') {
                        //     sendWebNavBuryingPoint({ title: item.name })
                        //   }
                        }}
                      >
                        {item.name}
                      </Dom>
                    )
                  })}
                    <div 
                        className={cn({
                          [st.item]: true,
                          [st['activeTabbar']]: ['/fakao/cooperate','/fakao/about','/fashuo/cooperate','/fashuo/about'].includes(location.pathname)
                        })}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                      >
                        {aboutUs.name}
                        {aboutUs.children && <div
                        >
                          <Icon
                            name={hover ? 'zhankaibeifen' : 'zhankaibeifen-copy'}
                            className={st['close-icon']}
                          />
                          <Item
                            data={aboutUs.children}
                            className={st['hover-tripe']}
                          />
                        </div>
                        }
                      </div>
                </div>
                <div className={st['searchBox']}>
                    <Icon
                      name='fangdajing'
                      onClick={() => searchClick()}
                      className={st['searchImg']}
                    />

                    {searchValue.length ? (
                        <div
                            className={st['clos']}
                            onClick={() => {
                                searchClos()
                            }}
                        >
                            <img src={clos} alt="" />
                        </div>
                    ) : (
                        ''
                    )}
                    <input
                        onChange={(e) => {
                            searchChange(e)
                        }}
                        value={searchValue}
                        onKeyDown={(e) => {
                            searchKeyDown(e)
                        }}
                        type="text"
                        placeholder="课程搜索"
                    />
                </div>
            </div>
        </div>
    )
}
